import { register } from '../../../JavaScript/Utils';

declare global {
  interface Window {
    Splide?: Splide,
    splide?: any
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any

export const LogoParade = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderContainer = el.querySelector('.splide-wrapper')

    const logoParade = new Splide(sliderContainer, {
      type: 'slide',
      height: 700,
      arrows: false,
      autoplay: el.dataset.autoplay || false,
      rewind: true,
      grid: {
        rows: 6,
        cols: 2,
        gap : {
          row: '1rem',
          col: '1rem',
        },
      },
      classes: {
        pagination: 'splide__pagination',
        page: 'splide__pagination__page'
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          height: 400,
          grid: {
            rows: 3,
            cols: 4,
          },
        },
        1024: {
          grid: {
            cols: 6,
          },
        }
      }
    })
    logoParade.mount( window.splide.Extensions )
  }
  init()
}

register('LogoParade', LogoParade)
